$primary-50: #fff6fd;
$primary-100: #ffeef9;
$primary-150: #fee6f6;
$primary-200: #fddef2;
$primary-250: #fbd4ef;
$primary-300: #f9c9eb;
$primary-350: #f7bfe9;
$primary-400: #f4b5e6;
$primary-450: #ef96da;
$primary-500: #e975cc;
$primary-550: #e150be;
$primary-600: #d912ae;
$primary-650: #bb0c94;
$primary-700: #9d067b;
$primary-750: #810264;
$primary-800: #65004d;
$primary-850: #4d003a;
$primary-900: #370028;
$primary-950: #220017;
$accent-50: #fffaf6;
$accent-100: #fff6ee;
$accent-150: #fef1e7;
$accent-200: #fdeddf;
$accent-250: #fee5ce;
$accent-300: #ffddbd;
$accent-350: #ffd6ab;
$accent-400: #ffce99;
$accent-450: #fdb678;
$accent-500: #fb9d58;
$accent-550: #f78139;
$accent-600: #f3631b;
$accent-650: #db5115;
$accent-700: #c33f0e;
$accent-750: #ab2e06;
$accent-800: #941b00;
$accent-850: #730f00;
$accent-900: #530400;
$accent-950: #350000;
$grey-50: #fafafa;
$grey-100: #f5f5f5;
$grey-150: #f0f0f0;
$grey-200: #ebebeb;
$grey-250: #e3e5e6;
$grey-300: #dcdfe0;
$grey-350: #d4d9db;
$grey-400: #cdd3d6;
$grey-450: #aab0b4;
$grey-500: #888f92;
$grey-550: #686f72;
$grey-600: #495054;
$grey-650: #3f4549;
$grey-700: #353b3f;
$grey-750: #2b3135;
$grey-800: #22272b;
$grey-850: #181c1f;
$grey-900: #0e1113;
$grey-950: #050709;
